import { createApp } from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import { GDialog } from 'gitart-vue-dialog';
import { vMaska } from 'maska';
import axios from 'axios';
import ModalView from '@/core/components/ModalView.vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'gitart-vue-dialog/dist/style.css';
import config from '../public/config/config.json';
import environment from './environment/environment';
import PrimeVue from 'primevue/config'
import Galleria from 'primevue/galleria'
import 'primevue/resources/themes/nova/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'




if (environment.environment.production) {
  console.log = () => { };
  console.warn = () => { };
  console.error = () => { };
}

axios.defaults.timeout = 60000;
axios.defaults.headers.post['Content-Type'] = 'application/json;';
axios.defaults.headers.post['Content-Encoding'] = 'charset=UTF-8';
axios.defaults.responseType = 'json';
axios.defaults.responseEncoding = 'charset=UTF-8';
axios.defaults.baseURL = `${environment.environment.apiEndPoint}`;

const app = createApp(App)
  .use(store)
  .use(router)
  .use(ModalView)
  .use(VueReCaptcha, { siteKey: config?.configuration.siteKey })
  .use(PrimeVue)
  .directive('maska', vMaska)
  .component('GDialog', GDialog)
  .component('ModalView', ModalView)
  .component('Galleria', Galleria)

library.add(faCheck)
app.component('font-awesome-icon', FontAwesomeIcon)



router.isReady()
  .then(() => app.mount('#app'));
